import PublicLayout from "../../layouts/publicLayout";
import {
  Box,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  FormHelperText,
  Typography,
  Stack,
  useTheme,
  useMediaQuery,
  Tooltip,
  Chip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import logo from "./../../assets/images/newLogo.png";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import ComponentBackdrop from "../../components/backdrop";
import { bannedDomains } from "../../data/bannedDomains";
import { passwordRules } from "../../data/passwordRules";
import { ArrowBack, Visibility, VisibilityOff } from "@mui/icons-material";
import poisum from "./../../assets/images/poisum.png";

import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import ForgotPassword from "./forgotpassword";
import { useApiClient } from "../../context/ApiClientContext";
import api from "../../helper/baseApi";
import ErrorAlert from "../../helper/errorAlert";


const validateEmail = (value) => {
  if (!value) return "Email is required.";

  const domain = value.split("@")[1];

  if (bannedDomains.includes(domain)) {
    return `Emails from ${domain} are not allowed. Use your work email address.`;
  }

  return ""; // valid
};

const validatePassword = (value) => {
  if (!value) return "Password is required.";
  if (value.length < 8) return "Password must be at least 8 characters";
  if (!/[A-Z]/.test(value))
    return "Password must contain at least one uppercase letter";
  if (!/[a-z]/.test(value))
    return "Password must contain at least one lowercase letter";
  if (!/[0-9]/.test(value))
    return "Password must contain at least one number";
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(value))
    return "Password must contain at least one special character";
  return "";
};

const PasswordRules = ({ password }) => (
  <Stack spacing={0.5}>
    {passwordRules.map((rule, idx) => {
      const passed = rule.test(password);
      return (
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          key={idx}
        >
          {passed ? (
            <CheckCircleIcon
              fontSize="small"
              sx={{ color: "success.main" }}
            />
          ) : (
            <CancelIcon
              fontSize="small"
              sx={{ color: "error.main" }}
            />
          )}
          <Typography
            variant="note"
            sx={{ color: passed ? "success.main" : "error.main" }}
          >
            {rule.label}
          </Typography>
        </Stack>
      );
    })}
  </Stack>
);

const Signup = () => {
  const theme = useTheme();
  const labelWidth = 170;
  const navigate = useNavigate();
  const { apiUrls: { accountMgtApiUrl, mobileApiUrl } } = useApiClient();

  const [openBackdrop, setOpenBackdrop] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [data, setData] = useState({
    username: "",
    password: "",
    confpassword: "",
    client_id: "poisum-mobile",
  });
  const [errors, setErrors] = useState({
    username: "",
    password: "",
    confpassword: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showconfPassword, setShowconfPassword] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false)

  useEffect(() => {
    const savedUsername = localStorage.getItem("email");
    if (savedUsername) {
      setData((prev) => ({
        ...prev,
        username: savedUsername,
      }));
    }
  }, []);

  const handleChange = (field, e) => {
    setData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const validate = (name, value) => {
    switch (name) {
      case "username":
      // return validateEmail(value);
      case "password":
      // return validatePassword(value);
      case "confpassword":
      // return validatePassword(value);
      default:
        return "";
    }
  };

  const handleLoginSuccess = async (user) => {

    console.log('mobileApiUrl', mobileApiUrl);

    try {
      const apiUrl = `${mobileApiUrl}signup`;
      const response = await api.get(apiUrl);

      // Redirect based on onboarding status
      if (response.status === 200) {
        navigate("/signin");
      } else {
        navigate("/signin");
      }
    } catch (error) {
      // console.error("Error checking onboarding:", error.message);
      navigate("/signin"); // fallback to dashboard
    }
  };


  const handleSubmit = async (event) => {
    event.preventDefault();

    setOpenBackdrop(true);

    const newErrors = {
      username: validate("username", data.username),
      password: validate("password", data.password),
      confpassword: validate("confpassword", data.confpassword),
    };

    setErrors(newErrors);

    const hasErrors = Object.values(newErrors).some(Boolean);
    if (hasErrors) {
      const errorMessage = Object.values(newErrors).filter(Boolean).join("\n");
      toast.error(errorMessage, { style: { zIndex: 9999 } });
      return;
    }

    try {
      // const response = await api.post(
      //   `${accountMgtApiUrl}SourceUser/SourceUserLogin`,
      //   data
      // );

      // const { access_token, refresh_token, user } = response?.data?.data || {};

      // if (response.status === 200) {
      //   toast.success("SignUp successful! Redirecting...", { style: { zIndex: 9999 } });
      //   setTimeout(() => handleLoginSuccess(user), 1500);
      // }
      handleLoginSuccess();
    } catch (error) {
      ErrorAlert(error, navigate);
    } finally {
      setOpenBackdrop(false);
    }
  };


  const handleForgotPasswordClick = () => {
    navigate("/forgot-password");
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <PublicLayout>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%", // Changed from 100vh to 100%
          maxWidth: { xs: "100%", md: 1100 },
          overflowY: "auto",
          boxShadow: { xs: "none", md: "0px 4px 20px rgba(0, 0, 0, 0.1)" },
          backgroundColor: 'background.main',
          borderRadius: { xs: "10px", md: "15px" },
          py: { xs: 4, sm: 10, md: 6 },
          px: { xs: 1, sm: 2, md: 12 },
          mx: { xs: 0, md: 2 },
          // "&::-webkit-scrollbar": {
          //   display: "none",
          // },
          minHeight: { xs: "50vh", md: "auto" },
          height: { xs: "100%", sm: "90%", md: "650px" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" }, // Stack on mobile, row on desktop
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
            gap: { xs: 2, md: 9 }, // Added gap between logo and form
          }}
        >
          {/* Logo Section */}
          <Box
            sx={{
              display: "flex",
              position: "relative",
              backgroundColor: "#ecece4a1", // light background
              borderRadius: "15px",
              p: { xs: 3, sm: 4, md: 5 }, // responsive padding
              width: "100%",
              maxWidth: { xs: 280, sm: 300, md: 450 }, // responsive width
              mx: "auto",
              mt: 15,
              height: { xs: 120, sm: 200, md: 300 }, // responsive height
            }}
          >
            {/* Faint Logo in Background */}
            <Box
              component="img"
              src={logo}
              alt="Logo"
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: {
                  xs: 120, // smaller on mobile
                  sm: 160,
                  md: 200,
                  lg: 250,
                },
                height: "auto",
                opacity: 0.08,
                zIndex: 0,
              }}
            />

            {/* Foreground Content */}
            <Stack
              sx={{
                position: "relative",
                zIndex: 1,
                textAlign: "left",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <Typography variant={isMobile ? "body" : "subtitle"} sx={{ fontWeight: "bold", color: "#8C8C8C" }}>
                Hi XXX,
              </Typography>
              <Typography variant={isMobile ? "body" : "subtitle"} sx={{ fontWeight: "bold", color: "#8C8C8C" }}>
                Your POISUM portal is ready!
              </Typography>
              <Typography variant={isMobile ? "body" : "subtitle"} sx={{ fontWeight: "bold", color: "#8C8C8C" }}>
                Let’s set up your first Admin User – this person will manage your POISUM portal
              </Typography>
            </Stack>
          </Box>

          <Box
            sx={{
              backgroundColor: "#39483f43",
              borderRadius: '15px',
              py: { xs: 2, sm: 3, md: 4 },
              px: { xs: 2, sm: 5, md: 6 },
              width: { xs: "100%", sm: "70%", md: "380px" },
              minHeight: { xs: "100%", sm: "90%", md: "450px" },
              // maxWidth: "480px",
            }}
          >
            <Typography
              variant="title"
              display="block"
              fontWeight={600}
              gutterBottom
              textAlign="center"
              mb={3}
              textTransform={'uppercase'}
              sx={{ color: '#fff' }}
            >
              POISUM portal
            </Typography>

            <Typography variant="subtitle" textTransform={'uppercase'} fontWeight={600} gutterBottom mb={2} sx={{ color: '#fff' }} display="block">
              First Admin Setup
            </Typography>
            <Box
              component="form"
              onSubmit={handleSubmit}
              noValidate
              autoComplete="off"
            >
              <Stack spacing={2} width="100%">
                {/* Email Field */}
                <Box>
                  <Typography variant="body" sx={{ mb: 1, fontWeight: 500, color: "#fff" }} display="block">
                    Email
                  </Typography>
                  <TextField
                    id="username"
                    placeholder="Enter your email"
                    name="email"
                    type="email"
                    // disabled
                    value={data.username}
                    onChange={(e) => handleChange("username", e)}
                    error={!!errors.username}
                    helperText={errors.username}
                    slotProps={{
                      input: {
                        autoComplete: "off",
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip title="Change email" arrow>
                              <IconButton
                                onClick={() => navigate(-1)}
                                edge="end"
                              >
                                <ArrowBack />
                              </IconButton>
                            </Tooltip>
                          </InputAdornment>
                        ),
                      },
                    }}
                    size="normal"
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "white",
                        borderRadius: 2,
                        "& fieldset": {
                          borderColor: "transparent",
                        },
                        "&:hover fieldset": {
                          borderColor: "primary.light",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "primary.main",
                        },
                      },
                    }}
                  />
                </Box>

                {/* Password Field */}
                <Box>
                  <Typography variant="body" sx={{ mb: 1, fontWeight: 500, color: "#fff" }} display="block">
                    Password
                  </Typography>
                  <TextField
                    placeholder="Enter your password"
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    value={data.password}
                    onChange={(e) => handleChange("password", e)}
                    error={!!errors.password}
                    helperText={
                      errors.password === "Password is required." ||
                        data.password === ""
                        ? errors.password
                        : ""
                    }
                    size="normal"
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "white",
                        borderRadius: 2,
                        "&:hover fieldset": {
                          borderColor: "primary.light",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "primary.main",
                        },
                      },
                    }}
                    autoComplete="off"
                    slotProps={{
                      input: {
                        autoComplete: 'off',
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip title={!showPassword ? 'Show Password' : 'Hide Password'} arrow>
                              <IconButton
                                onClick={() => setShowPassword((prev) => !prev)}
                                edge="end"
                              >
                                {!showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </Tooltip>
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                </Box>
                {/* Confirm Password Field */}
                <Box>
                  <Typography variant="body" sx={{ mb: 1, fontWeight: 500, color: "#fff" }} display="block">
                    Confirm Password
                  </Typography>
                  <TextField
                    placeholder="Enter your confirm password"
                    id="confpassword"
                    name="confpassword"
                    type={showconfPassword ? "text" : "password"}
                    value={data.confpassword}
                    onChange={(e) => handleChange("confpassword", e)}
                    error={!!errors.confpassword}
                    helperText={
                      errors.confpassword === "Confirm Password is required." ||
                        data.confpassword === ""
                        ? errors.confpassword
                        : ""
                    }
                    size="normal"
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "white",
                        borderRadius: 2,
                        "&:hover fieldset": {
                          borderColor: "primary.light",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "primary.main",
                        },
                      },
                    }}
                    autoComplete="off"
                    slotProps={{
                      input: {
                        autoComplete: 'off',
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip title={!showconfPassword ? 'Show Password' : 'Hide Password'} arrow>
                              <IconButton
                                onClick={() => setShowconfPassword((prev) => !prev)}
                                edge="end"
                              >
                                {!showconfPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </Tooltip>
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                </Box>

                {/* Validation */}
                <Box sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  gap: 2,
                }}>
                  {/* Password validation rules */}
                  {data.password && errors.password && (
                    <Box sx={{ flex: 1 }}>
                      <PasswordRules password={data.password} />
                    </Box>
                  )}
                </Box>

                {/* Forgot Password and Validation */}
                {/* <Box sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  // gap: 2,
                }}> */}
                  {/* Password validation rules */}
                  {/* {data.password && errors.password && (
                    <Box sx={{ flex: 1 }}>
                      <PasswordRules password={data.password} />
                    </Box>
                  )} */}

                  {/* Forgot Password button */}
                  {/* <Box sx={{
                    textAlign: { xs: "left", sm: "right" },
                    width: { xs: "100%", sm: "auto" }
                  }}>
                    <Button
                      variant="text"
                      sx={{
                        textTransform: "none",
                        minWidth: "auto",
                        padding: 0,
                        whiteSpace: "nowrap",
                        color: "#fff"
                      }}
                      onClick={handleForgotPasswordClick}
                    >
                      Forgot Password?
                    </Button>
                  </Box> */}
                {/* </Box> */}

                {/* Sign In Button */}
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  size="large"
                  sx={{
                    backgroundColor: "primary.main",
                    // mt: 2,
                    py: 1.5,
                    fontSize: 14,
                    textTransform: "capitalize"
                  }}
                >
                  Sign Up &nbsp; <Chip color="error" size="small" label="WIP" />
                </Button>
              </Stack>

              {errors.form && (
                <FormHelperText
                  sx={{
                    color: "error.main",
                    textAlign: "center",
                    // marginTop: 2,
                  }}
                >
                  {errors.form}
                </FormHelperText>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        component="img"
        src={poisum}
        alt="poisum"
        sx={{
          width: "100%",
          maxWidth: { xs: "100%", md: 1000 },
          mt: { xs: -1.5, sm: -3.5, md: -6 }, // keep slight overlap
          mx: "auto",
          display: "block",
          opacity: 0.9, // optional like your screenshot
        }}
      />

      {/* <ForgotPassword open={dialogOpen} handleClose={handleDialogClose} setOpenBackdrop={setOpenBackdrop} /> */}
      <ComponentBackdrop openBackdrop={openBackdrop} />
    </PublicLayout>
  );
};

export default Signup;
